module["exports"] = [
  "###/######",
  "###/## ## ##", 
  "### ## ## ##",
  "###/### ###",
  "##########",
  "04##/### ###",
  "04## ## ## ##",
  "00324 ## ## ##",
  "+324 ## ## ## ##"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/nl_BE/phone_number/formats.js
// module id = 3336
// module chunks = 1610